import "./styles.css";

// 1. ADD useMemo TO IMPORTS
import React, { useEffect, useRef, useState, useMemo } from "react";
import { createRoot } from "react-dom/client";
import createGlobe from "cobe";
import usePartySocket from "partysocket/react";

import type { OutgoingMessage } from "../shared";
import type { LegacyRef } from "react";

function App() {
	const canvasRef = useRef<HTMLCanvasElement>();
	const [counter, setCounter] = useState(0);
	
	const positions = useRef<
		Map<
			string,
			{
				location: [number, number];
				size: number;
			}
		>
	>(new Map());

    // --- FIX STARTS HERE ---
    // We use useMemo so this object is created ONLY ONCE when the app loads.
    // This prevents the infinite disconnect/reconnect loop.
    const partyQuery = useMemo(() => {
        const query: Record<string, string> = {};
        
        // Safe check for Vite environment
        try {
            // @ts-ignore
            if (import.meta.env.DEV) {
                const urlParams = new URLSearchParams(window.location.search);
                const fakeIP = urlParams.get("fakeIP");
                if (fakeIP) {
                    query.ip = fakeIP;
                    console.log(`[Dev Mode] Spoofing IP: ${fakeIP}`);
                }
            }
        } catch (e) {
            console.log("Dev mode check skipped");
        }
        return query;
    }, []); // Empty dependency array = calculate once and never again
    // --- FIX ENDS HERE ---

	const socket = usePartySocket({
		room: "default",
		party: "globe",
        // Now we pass the stable object reference
        query: partyQuery,
		onMessage(evt) {
			const message = JSON.parse(evt.data as string) as OutgoingMessage;

			switch (message.type) {
				case "add-marker":
					positions.current.set(message.position.id, {
						location: [message.position.lat, message.position.lng],
						size: message.position.id === socket.id ? 0.1 : 0.05,
					});
					break;

				case "remove-marker":
					positions.current.delete(message.id);
					break;

				case "update-count":
					setCounter(message.count);
					break;
			}
		},
	});

	useEffect(() => {
		let phi = 0;

		const globe = createGlobe(canvasRef.current as HTMLCanvasElement, {
			devicePixelRatio: 2,
			width: 400 * 2,
			height: 400 * 2,
			phi: 0,
			theta: 0,
			dark: 1,
			diffuse: 0.8,
			mapSamples: 16000,
			mapBrightness: 6,
			baseColor: [0.3, 0.3, 0.3],
			markerColor: [0.8, 0.1, 0.1],
			glowColor: [0.2, 0.2, 0.2],
			markers: [],
			opacity: 0.7,
			onRender: (state) => {
				state.markers = [...positions.current.values()];
				state.phi = phi;
				phi += 0.01;
			},
		});

		return () => {
			globe.destroy();
		};
	}, []);

	return (
		<div className="App">
			<h1>Where's everyone at?</h1>
			{counter !== 0 ? (
				<p>
					<b>{counter}</b> {counter === 1 ? "person" : "people"} connected.
				</p>
			) : (
				<p>&nbsp;</p>
			)}

			<canvas
				ref={canvasRef as LegacyRef<HTMLCanvasElement>}
				style={{ width: 400, height: 400, maxWidth: "100%", aspectRatio: 1 }}
			/>
			
			<p>
				Wanna go back to moob453.com? <a href="https://moob453.com">Click Here</a>{" "}
			</p>
			<p>
				Powered by <a href="https://cobe.vercel.app/">🌏 Cobe</a>,{" "}
				<a href="https://www.npmjs.com/package/phenomenon">Phenomenon</a> and{" "}
				<a href="https://npmjs.com/package/partyserver/">🎈 PartyServer</a>
			</p>

		</div>
	);
}

// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
createRoot(document.getElementById("root")!).render(<App />);